module.exports = __webpack_public_path__ + "src/assets/fonts/方正颜宋简体_粗.70bec3fa.TTF";